import { BossBar } from "./components/BossBar.js";
import { DevPanel } from "./components/DevPanel.js";
import { EndScreen } from "./components/EndScreen.js";
import { ExtractionBanner } from "./components/ExtractionBanner.js";
import { LevelUpOverlay } from "./components/LevelUpOverlay.js";
import { Lobby } from "./components/Lobby.js";
import { PauseMenu } from "./components/PauseMenu.js";
import { PlayerHud } from "./components/PlayerHud.js";
import { Prompts } from "./components/Prompts.js";
import { RunStrip } from "./components/RunStrip.js";

/** Root UI layer (floats above the 3D canvas). Components subscribe to the store. */
export function App() {
  return (
    <>
      <RunStrip />
      <BossBar />
      <ExtractionBanner />
      <Prompts />
      <PlayerHud />
      <LevelUpOverlay />
      <Lobby />
      <EndScreen />
      <PauseMenu />
      <DevPanel />
      <BuildTag />
    </>
  );
}

/** Small, unobtrusive build/version tag (always < 1.0.0 until first playable). */
function BuildTag() {
  return (
    <div class="pointer-events-none fixed bottom-1 right-1.5 z-50 select-none font-mono text-[10px] leading-none text-white/30">
      v{__APP_VERSION__}
    </div>
  );
}
